import { HttpErrorResponse, HttpInterceptorFn, HttpStatusCode } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { ErrorModalService } from '@shared/components/ui/error-modal/error-modal.service';
import { SKIP_ERROR_MODAL_HEADER } from '@constants';

/** URLs excluidas del manejo global de errores */
const EXCLUDED_URLS = [
  '/i18n/',
  '/assets/i18n/',
  '/start'
];

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const errorModal = inject(ErrorModalService);

  const isExcluded = EXCLUDED_URLS.some((url) => req.url.includes(url));
  if (isExcluded) {
    return next(req);
  }

  if (req.headers.has(SKIP_ERROR_MODAL_HEADER)) {
    return next(req.clone({ headers: req.headers.delete(SKIP_ERROR_MODAL_HEADER) }));
  }

  return next(req).pipe(
    catchError((error: unknown) => {
      if (error instanceof HttpErrorResponse) {
        if (error.status === HttpStatusCode.Unauthorized) {
          errorModal.show('401');
        } else {
          const errorCode = extractErrorCode(error);
          errorModal.show(errorCode);
        }
      }
      return throwError(() => error);
    })
  );
};

function extractErrorCode(error: HttpErrorResponse): string | undefined {
  if (error.error && typeof error.error === 'object') {
    const body = error.error as Record<string, unknown>;
    if (typeof body['message'] === 'string') {
      return body['message'];
    }
    if (typeof body['status'] === 'string') {
      return body['status'];
    }
  }
  return undefined;
}
